// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const FALLBACK_LANGUAGE = 'en';

export const LANGUAGES = {
  en: 'English',
  fr: 'Français',
};
